import { render } from "./FreeMode.vue?vue&type=template&id=4dc11582&scoped=true&ts=true"
import script from "./FreeMode.vue?vue&type=script&lang=ts"
export * from "./FreeMode.vue?vue&type=script&lang=ts"

import "./FreeMode.vue?vue&type=style&index=0&id=4dc11582&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc11582"]])

export default __exports__